export default function Tabss ({ tabs, content, firstHide = false}) {
    if (firstHide) {
       $(content).hide();
    } else  {
       $(content).not(':first').hide();
       $(`${content}:first`).addClass('active');
       $(`${tabs}:first`).addClass('active');
    }
       
    $(tabs).on('click', function () {
       $(tabs).removeClass('active').eq($(this).index()).addClass('active');
       $(content).hide().removeClass('active').eq($(this).index()).fadeIn('1000').addClass('active');
    })
 }